module.exports = __webpack_public_path__ + "static/media/Brunel-Johnson-Street-Photography.3c077fd5.jpg";